import { rowDirection } from "./groundRowEditing";

// Pixel-sized capture with a world-space cap: zooming out must not pull a
// row metres away. Only along-row translation changes; pitch stays free.
export function alignGroundRow(tables, index, delta, azimuth, scale, free = false) {
  const row = tables[index];
  if (!row) return { delta, guide: null };
  const u = rowDirection(azimuth), c = { x: u.y, y: -u.x };
  const mid = t => ({ x: (t.start[0] + t.end[0]) / 2, y: (t.start[1] + t.end[1]) / 2 });
  const p = mid(row);
  p.x += delta.x; p.y += delta.y;
  const nearby = tables.map((t, i) => {
    const q = mid(t), across = (q.x - p.x) * c.x + (q.y - p.y) * c.y;
    const dx = t.end[0] - t.start[0], dy = t.end[1] - t.start[1];
    return { t, i, across, parallel: Math.abs(dx * c.x + dy * c.y) < 1e-5 * Math.max(1, Math.hypot(dx, dy)) };
  }).filter(n => n.i !== index && n.parallel && Math.abs(n.across) > 0.01);
  const neighbours = [-1, 1].map(sign => nearby.filter(n => n.across * sign > 0)
    .sort((a, b) => Math.abs(a.across) - Math.abs(b.across))[0]).filter(Boolean);
  const candidates = neighbours.flatMap(({ t }) => ["start", "end"].flatMap(end => ["start", "end"].map(targetEnd => {
    const source = { x: row[end][0] + delta.x, y: row[end][1] + delta.y };
    const target = { x: t[targetEnd][0], y: t[targetEnd][1] };
    const correction = (target.x - source.x) * u.x + (target.y - source.y) * u.y;
    return { source, target, correction, label: t.label };
  })));
  candidates.sort((a, b) => Math.abs(a.correction) - Math.abs(b.correction));
  const best = candidates[0];
  if (!best) return { delta, guide: null };
  const snapped = !free && Math.abs(best.correction) <= Math.min(6 * scale, 0.3);
  const correction = snapped ? best.correction : 0;
  const source = { x: best.source.x + correction * u.x, y: best.source.y + correction * u.y };
  const remaining = best.correction - correction;
  return {
    delta: { x: delta.x + correction * u.x, y: delta.y + correction * u.y },
    guide: { source, target: best.target, projected: { x: source.x + remaining * u.x, y: source.y + remaining * u.y },
      distance: Math.abs(remaining), snapped, label: best.label },
  };
}
